// extracted by mini-css-extract-plugin
export default {"input-wrapper":"MultiselectSearchableDropdown_input-wrapper__ycbdv"};